module.exports = __webpack_public_path__ + "static/media/graph_326.86fd18bb.png";